import { TloginPara, TUserInfoType, TResetPwdPara, TVerCodePara } from "@/module/login";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 获取用户登录
export const loginApi = (data: TloginPara) => {
    return request<TloginPara, string>({
        url: '/api/user/users/login',
        method: 'POST',
        data
    })
}

// 获取当前用户信息
export const getCurrUser = () => {
    return request<TUserInfoType>({
        url: '/api/user/users/current',
        method: "GET"
    })
}

// 重置密码
export const getResetPwd = (data: TResetPwdPara) => {
    return request<TResetPwdPara, boolean>({
        url: '/api/user/users/resetbyphone',
        method: "POST",
        data
    })
}

// 发送重置密码验证码
export const getVerCode = (data: TVerCodePara) => {
    return request<TVerCodePara, string>({
        url: '/api/user/users/resetsend',
        method: "POST",
        data
    })
}
